import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  forwardRef,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  inject,
  DestroyRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { createMask } from '@ngneat/input-mask';
import { Subject } from 'rxjs';
import { InputMaskModule } from '@ngneat/input-mask';

@Component({
  selector: 'app-mdbp-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule, 
    InputMaskModule
  ],
  templateUrl: './mdb-input.component.html',
  styleUrls: ['./mdb-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MdbpInputComponent),
    multi: true,
  }]
})

export class MdbpInputComponent implements AfterViewInit, OnDestroy, ControlValueAccessor {
  destroyRef = inject(DestroyRef)
  static nextId = 0;

  @ViewChild('inputName') inputName: ElementRef;
  @ContentChild('inputNameC')inputNameC:ElementRef;
  

  @Input() label:string;
  @Input() type: string = 'text';
  @Input() autocomplete: string | null = null;
  @Input() isCurrencyMask:boolean = false;
  @Input() customInput:boolean = false;
  @Input() placeholder:string = '';
  @Input() readonly:boolean = false;


  @Input() maxLength: number = 128;
  @Input() showMaxLength: boolean = true;
  @Input() phoneInputMask: string | null = null;

  phoneMask = createMask("+1 (999) 9999999");

  public focused = false;
  

  @Input()
  get value(): any {
    return this.controlName.value;
  }

  @Output()
  public blur = new EventEmitter();
  
  set value(value: any) {
    this.controlName.setValue(value.trim());
    this.stateChanges.next();
  }

  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};

  public takeUntilSubject = new Subject();
  public stateChanges = new Subject<void>();
  
  controlName = new UntypedFormControl();
  
  constructor(
    private _elementRef: ElementRef<HTMLElement>,
  ) {
    this.controlName.valueChanges.pipe(
      takeUntilDestroyed()
    ).subscribe(value => {
      try {
        this.onChangeCallback(value);
      } catch(e) { }
    });
  }

  ngAfterViewInit(): void {
    let inputMdb

    if(this.inputName){
      inputMdb = this.inputName.nativeElement
    }
    if(this.inputNameC){
      inputMdb = this.inputNameC.nativeElement
    }
    if(this.controlName.value !== ''){
      inputMdb?.classList.add('active')
    }
    
    this.controlName.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((val)=>{
      if(this.onChangeCallback){
        this.onChangeCallback(val)
        this.toggleClassActive(val,inputMdb)
      }
    })
  }

  setDescribedByIds(ids: string[]) {
    const controlElement = this._elementRef.nativeElement
      .querySelector('.app-input-container')!;
    controlElement.setAttribute('aria-describedby', ids.join(' '));
  }

  ngOnDestroy(): void {
    this.stateChanges.complete();
  }

  toggleClassActive(val,inputMdb){
    if(val !== ''){
      inputMdb?.classList.add('active')
    }else{
      inputMdb?.classList.remove('active')
    }
  }

  registerOnChange(fn: any) { 
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }
  writeValue(value: string) {
    this.controlName.setValue(value)
  }

  onContainerClick(event: MouseEvent) {
    this.controlName.touched
    this.controlName.markAsTouched()
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      
    }
    this._elementRef.nativeElement.querySelector('input').focus();
    this.focused = true   

  }

  setAutocomplete(autocomplete) {
    if (autocomplete === 'off') {
      this.inputName.nativeElement.setAttribute('autocomplete', 'chrome-off');
    }
  }

  onBlur(){
    this.focused = false
    this.blur.next(null);
  }

}